import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { DIRECTIVES } from './directives/directives';
import { COMPONENTS } from './components/components';
import { MODALS } from './modals/modals';
import { PIPES } from './pipes/pipes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectionCheckerPipe } from './pipes/selection-checker.pipe';
import { ObjToStringPipe } from './pipes/obj-to-string.pipe';

@NgModule({
  declarations: [...COMPONENTS, ...MODALS, ...PIPES, ...DIRECTIVES, SelectionCheckerPipe, ObjToStringPipe],
  imports: [CommonModule, IonicModule, RouterModule, ReactiveFormsModule, FormsModule],
  exports: [...COMPONENTS, ...MODALS, ...PIPES, ...DIRECTIVES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
